export const environment = {
  production: false,
  documentsUrl: 'https://api-documents-test.john-hancock.me/api',
  emailUrl: 'https://api-email-test.john-hancock.me/api',
  processUrl: 'https://api-process-test.john-hancock.me/api',
  cmsUrl: 'https://www-test.john-hancock.me/cms',
  bankIdUrl: 'https://api-std-bankid-gw-test.sealthedeal.se/service',
  useBankId: false
}
